import { ROUTES } from 'constants/routes'
import * as Pages from 'pages'
import type { RouteObject } from 'react-router-dom'

import { PrivateRoute } from './private'

const budgetsRoutes: RouteObject[] = [
  {
    path: ROUTES.BUDGETS.LIST,
    element: (
      <PrivateRoute>
        <Pages.Budgets />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.BUDGETS.CREATE,
    element: (
      <PrivateRoute>
        <Pages.AddBudgets />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.BUDGETS.EDIT(':id'),
    element: (
      <PrivateRoute>
        <Pages.EditBudgets />
      </PrivateRoute>
    ),
  },
]

export default budgetsRoutes
